import { GridCellProps } from '@progress/kendo-react-grid';
import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
import GridCellBase from 'src/components/GridCellBase';

const BudgetAmountPercentage = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const value = dataItem[field];
  const newValue =
    Number.isFinite(Number(value)) && !isNaN(Number(value))
      ? `${(Math.round(Number(value) * 100) / 100).toFixed(2)}%`
      : 'N/A';

  return (
    <GridCellBase
      {...props}
      title={newValue}
      style={{
        ...validateNumber(field, dataItem),
      }}
      rowSelectionEnabled
    >
      <span>{newValue}</span>
    </GridCellBase>
  );
};

export default BudgetAmountPercentage;
